
export const OEAssetSelectionType = {
    dummy:                  'dummy',
    animation:              'animation',
    presentation:           'presentation',
    image:                  'image',
    video:                  'video',
    web:                    'web',
    pdf:                    'pdf',
};

OEAssetSelectionType.all = [
    OEAssetSelectionType.dummy,
    OEAssetSelectionType.animation,
    OEAssetSelectionType.presentation,
    OEAssetSelectionType.image,
    OEAssetSelectionType.video,
    OEAssetSelectionType.web,
    OEAssetSelectionType.pdf
];

OEAssetSelectionType.allFunctional = [
    OEAssetSelectionType.animation,
    OEAssetSelectionType.presentation,
    OEAssetSelectionType.image,
    OEAssetSelectionType.video,
    OEAssetSelectionType.web,
    OEAssetSelectionType.pdf
];

OEAssetSelectionType.mediaCenter = [
    OEAssetSelectionType.image,
    OEAssetSelectionType.video,
    OEAssetSelectionType.web,
    OEAssetSelectionType.pdf
];